import { useEffect, useState } from "react";
import { Backend } from "../services/Backend";
import EditPermissionItem from "../layout/EditPermissionItem";

export default function AdminPermissionsPage() {
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        Backend.get("subscription")
            .then(res => preparePermissionData(res));
    }, []);

    const preparePermissionData = (data) => {
        const tmpPermissions = [];

        data.forEach(item => {
            const subPermissions = item.permissions.map(permission => 
                ({ id: permission.id, description: permission.description, subscriptionId: item.id}));

            tmpPermissions.push(...subPermissions);
        });

        setPermissions(tmpPermissions);
    };
    
    return <div>
        <h1 className="font-semibold text-3xl">Permissions</h1>

        {permissions.map(item => <EditPermissionItem permission={item} />)}
    </div>
}